__webpack_require__.p = "/TypingDuck/";